import React from 'react'
import { AddressProps } from './types'
import { isValidFloat, numberMinMax } from '@cbgms/base/utils/validations'
import Input from '@cbgms/components/form/Material/Input'
import { normalizeFloat } from '@cbgms/base/utils/normalizers'
import { useTranslation } from 'react-i18next'
import { inputBaseClasses } from '@mui/material/InputBase'

const fieldStyle = {
  margin: 2,
  width: 'auto',
  display: 'block',
  minWidth: 125,
  [`& .${inputBaseClasses.input}`]: {
    border: 'unset !important' // styling collision with semantic causes a double border
  }
}

type LatitudeLongitudeProps = Pick<AddressProps, 'prefix' | 'allFieldsDisabled'>

const validateLongitude = numberMinMax(-180, 180)
const validateLatitude = numberMinMax(-90, 90)

const LatitudeLongitudeInputs: React.FC<LatitudeLongitudeProps> = ({ prefix, allFieldsDisabled }) => {
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <Input
        sx={fieldStyle}
        label={t('global.latitude')}
        name={`${prefix}Latitude`}
        validate={[isValidFloat, validateLatitude]}
        normalize={normalizeFloat}
        data-testid={`${prefix.toLowerCase()}-latitude-input`}
        disabled={allFieldsDisabled}
        required
      />
      <Input
        sx={fieldStyle}
        label={t('global.longitude')}
        name={`${prefix}Longitude`}
        validate={[isValidFloat, validateLongitude]}
        normalize={normalizeFloat}
        data-testid={`${prefix.toLowerCase()}-longitude-input`}
        disabled={allFieldsDisabled}
        required
      />
    </React.Fragment>
  )
}

LatitudeLongitudeInputs.displayName = 'LatitudeLongitudeInputs'
export default LatitudeLongitudeInputs
